// Run E2 J3: the one canon season name per season, EN + ES.
// EN: context/PE_RULES_FOR_CC.md and PE_CANON_LIVE.md (as named on the live
// enrichment site). ES: the enrichment site's es.json (frontend/src/locales,
// projectExplore.season), because no other approved Spanish season name exists.
// The box DB (pe_seasons.title, teacher-guide header.season) gets the same
// names through gauntlet/run-e2-20261030/sql/e2-3-names.sql.

export const PE_SEASON_NAMES: Record<number, { en: string; es: string }> = {
  1: { en: "Neighborhood Treasures", es: "Tesoros del Vecindario" },
  2: { en: "Journey to Wonder", es: "Viaje a la Maravilla" },
  3: { en: "The Maker's Workshop", es: "El Taller del Creador" },
  4: { en: "Seeds of Tomorrow", es: "Semillas del Mañana" },
};

/** "Season 1: Neighborhood Treasures" / "Temporada 1: Tesoros del Vecindario". */
export function peSeasonLabel(
  seasonNumber: number,
  lang: "en" | "es" = "en",
  sep = ": ",
): string {
  const names = PE_SEASON_NAMES[seasonNumber];
  const word = lang === "es" ? "Temporada" : "Season";
  if (!names) return `${word} ${seasonNumber}`;
  return `${word} ${seasonNumber}${sep}${names[lang]}`;
}
